import React from "react";
import { Award, Target, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import ProgramPageLayout from "../../components/shared/ProgramPageLayout";

const ProjectOlympiads: React.FC = () => {
  return (
    <ProgramPageLayout slug="project-olympiads" theme="purple">
      {(program) => (
        <>
          {/* Program Features from Database */}
          {program.features && program.features.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Features</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
                {program.features.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 * index }}
                    className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
                  >
                    <div className="flex-shrink-0">
                      <CheckCircle className="h-6 w-6 text-purple-500" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{feature}</h3>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Program Overview</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Academic Project Olympiads provide students with the opportunity to participate in competitive academic events, develop research projects, and compete against peers from around the world. Our program prepares students for various international competitions and olympiads.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Competition Areas</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <Target className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Mathematics and Science Olympiads</span>
              </li>
              <li className="flex items-start">
                <Target className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Research project competitions</span>
              </li>
              <li className="flex items-start">
                <Target className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Innovation and entrepreneurship challenges</span>
              </li>
              <li className="flex items-start">
                <Target className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">International academic competitions</span>
              </li>
              <li className="flex items-start">
                <Target className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Team-based problem solving events</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">Benefits</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <Award className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Enhanced problem-solving and critical thinking skills</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">International recognition and awards</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">College application enhancement</span>
              </li>
              <li className="flex items-start">
                <Award className="h-5 w-5 text-purple-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Networking with top students worldwide</span>
              </li>
            </ul>
          </motion.div>
        </>
      )}
    </ProgramPageLayout>
  );
};

export default ProjectOlympiads;

